import script from "./PoliticasGST.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticasGST.vue?vue&type=script&setup=true&lang=js"

import "./PoliticasGST.vue?vue&type=style&index=0&id=4a2af1c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2af1c4"]])

export default __exports__